<template>
    <div id="view-model">
        <div class="cheader-viewmodel">
            <div class="hpBanner-loge">
                <router-link class="hpBanner-pointer" :to="{ path: '/' }" tag="div"></router-link>
                <embed class="hpBanner-img" :src="`${$baseUrl}dataMock/homePage/pkpmLogo.png`" />

                <!-- <h1 ></h1> -->
                <h1 class="hpBanner-ctx">丨{{ '模型浏览 — ' + titleName }}</h1>
                <!-- <router-link :to="{path: '/devcenter'}"  class="hpBanner-ctx" tag="h1">丨{{headerTile}}</router-link> -->
            </div>
        </div>
        <ViewModel
            v-if="modelOptions.length"
            :isShow2d="true"
            :configAddin="[
                {
                    id: 'OBVAddins.Marker',
                    noButton: false,
                    unRepeatMarkerPos: false,
                    enableMarkerMove: true,
                },
            ]"
            :viewModelItem="modelOptions"
            :getAccessToken="getAccessToken"
            @bimbox-viewer="obvViewerApi"
        ></ViewModel>
    </div>
</template>

<script>
import DynamicLoad from 'src/common/js/dynamicLoad';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { getObjectViewToken } from 'src/utils/modelUtils';
import { base64UrlDecode } from 'src/utils/commonUtils';
import { getModelAssembleView } from '../../utils/modelAssemble';
import { analysisFileType } from '../../utils/commonUtils';
import { getConverterTypes } from '../../utils/jobUtils';
import { getModelDocument } from '../../utils/ModelDocumentUtils';

export default {
    components: {},
    name: 'viewModel',
    props: {
        showToolBar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            modelOptions: [],
            token: '',
            convertObj: '',
            obvApi: undefined,
            showViewer: false,
            fileTypes: null,
        };
    },
    computed: {
        titleName() {
            return base64UrlDecode(this.$route.query.name);
        },
    },
    methods: {
        uninitializeViewer(obvApi) {
            if (obvApi) {
                obvApi.uninitializeViewer();
            }
        },
        obvViewerApi(obvApi) {
            this.obvApi = obvApi;
        },
        getAccessToken(cb) {
            // todo
            getObjectViewToken().then((res) => {
                cb(res.data.newToken, 60000);
            });
        },
        // 单个模型加载
        modelView(query) {
            const tempUrn = base64UrlDecode(query.urn);
            const urn = `${tempUrn}`;
            const guid = base64UrlDecode(query.guid);
            const jobType = query.jobType && base64UrlDecode(query.jobType);
            this.modelOptions.push({
                documentUrn: urn,
                guid: guid,
                converterType: jobType,
            });
        },
        // 模型组装加载
        modelAssembleView(assembleId, convertType) {
            getModelAssembleView(assembleId).then(async (data) => {
                this.modelOptions = [];
                // if (convertType === 'obv') {
                //     this.obvModelAssembleView(data);
                // } else if (convertType === 'lod') {
                //     this.lodModelAssembleView(data, convertType);
                // }
                data.forEach((item, index) => {
                    const options = {
                        documentUrn: item.urn,
                        guid: item.guid,
                        converterType: this.getJobType(analysisFileType(data[index].urn), convertType),
                        offset: { x: item.x, y: item.y, z: item.z, r: item.r },
                    };
                    this.modelOptions.push(options);
                });
            });
        },
        // 全量模型组装加载
        obvModelAssembleView(data) {
            data.forEach((item, index) => {
                const options = {
                    documentUrn: item.urn,
                    guid: item.guid,
                    converterType: this.getJobType(analysisFileType(data[index].urn), 'obv'),
                    offset: { x: item.x, y: item.y, z: item.z, r: item.r },
                };
                this.modelOptions.push(options);
            });
        },
        // 流式模型组装加载
        lodModelAssembleView(data, convertType) {
            getObjectViewToken().then(async (res) => {
                // 区分新旧数据
                const token = res.data.newToken;
                const fileInfo = {
                    urn: data[0].urn,
                    converterType: this.getJobType(analysisFileType(data[0].urn), 'lod'),
                    convertType: convertType,
                };
                try {
                    const obvDocument = await getModelDocument(token, fileInfo);
                    const isNewData =
                        obvDocument.getViewableItems(obvDocument.getRootItem()) &&
                        obvDocument.getViewableItems(obvDocument.getRootItem()).length > 0
                            ? true
                            : false;
                    if (isNewData) {
                        this.newLodModelAssembleView(data);
                    } else {
                        this.oldLodModelAssembleView(data);
                    }
                } catch (err) {
                    if (err.errorMessage && err.errorMessage.errorCode === 12) {
                        this.oldLodModelAssembleView(data);
                    } else {
                        this.$message({
                            type: 'error',
                            message: '该模型文件无法加载或缺失模型，请重新转换或组装！',
                            duration: 0,
                            offset: 120,
                        });
                        console.error('模型无法加载！');
                    }
                }
            });
        },
        // 新LOD数据的加载
        newLodModelAssembleView(data) {
            data.forEach((item) => {
                const options = {
                    documentUrn: item.urn,
                    guid: item.guid,
                    packageParams: { x: item.x, y: item.y, z: item.z, r: item.r },
                    converterType: this.getJobType(analysisFileType(item.urn), 'lod'),
                };
                this.modelOptions.push(options);
            });
        },
        // 旧LOD数据的加载
        oldLodModelAssembleView(data) {
            data.forEach((item) => {
                const options = {
                    documentUrn: item.urn,
                    guid: item.guid,
                    packageParams: { x: item.x, y: item.y, z: item.z, r: item.r },
                    converterType:
                        analysisFileType(item.urn) === 'gim'
                            ? 'gim-lod'
                            : analysisFileType(item.urn) === 'tifzip'
                            ? 'tifzip-lod'
                            : 'obmx-lod',
                };
                this.modelOptions.push(options);
            });
        },
        // 获取不同格式对应的jobType(除dwg2d)
        getJobType(fileFormat, convertWay) {
            if (fileFormat === 'dwg') {
                // return `dwg3d-${convertWay}`;
                return `dwg-${convertWay}`;
            } else {
                let tempConverters = this.fileTypes[fileFormat].converters;
                for (let index = 0; index < tempConverters.length; index++) {
                    let tempType = tempConverters[index].name.split('-');
                    if (tempType[tempType.length - 1] === convertWay) {
                        return tempConverters[index].name;
                    }
                }
            }
        },
        loadObvFile() {
            return new Promise((resolve, reject) => {
                DynamicLoad.loadCss(RuntimeUtils.instance.obv5CssPath);
                DynamicLoad.loadResourceLink(RuntimeUtils.instance.obv5PropertiesPath);
                DynamicLoad.loadJs(RuntimeUtils.instance.obv5JsPath).then(() => {
                    resolve();
                });
            });
        },
    },
    async created() {
        this.loadObvFile().then(() => {
            const query = this.$route.query;
            if (query.viewModelType && query.viewModelType === 'assemble' && query.assembleId) {
                getConverterTypes().then((res) => {
                    this.fileTypes = res.filetypes;
                    this.modelAssembleView(query.assembleId, query.convertType);
                });
            } else {
                this.modelView(query);
            }
        });
    },
    destroyed() {
        if (obvApi) {
            obvApi.uninitializeViewer();
        }
    },
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
#view-model
  position absolute
  height 100%
  width 100%

  .cheader-viewmodel
    width 100%
    height 60px
    background-color $background-blue

    .hpBanner-loge
      z-index 99
      position absolute
      left 5.3%
      top 12px
      display flex
      align-items center

      .hpBanner-pointer
        z-index 99
        cursor pointer
        background-color transparent
        position absolute
        width 120px
        height 26px

      .hpBanner-img
        position relative
        width 120px
        height 26px

      .hpBanner-ctx
        width auto
        height 36px
        color $font-white
        font-size $font-size-logo
        font-weight bold
        line-height 36px

  #obv-wrapper
    position relative
    width 100%
    height calc(100% - 60px)
    background #161616

.cheader-viewmodel .obv-tree-infinite .tree-item .tree-node > .checkbox
  display inline-block

/* .bimbox-toolbar
display:none!important */
</style>



// WEBPACK FOOTER //
// src/components/ViewModel/ViewModel.vue